import icon1 from './icon-1.json';
import icon2 from './icon-2.json';
import icon3 from './icon-3.json';
import icon4 from './icon-4.json';
import icon5 from './icon-5.json';
import icon6 from './icon-6.json';
import icon7 from './icon-7.json';
import icon8 from './icon-8.json';
import icon9 from './icon-9.json';
import icon10 from './icon-10.json';
import icon11 from './icon-11.json';
import icon12 from './icon-12.json';

export const WEATHER_ICONS = {
	'01d': icon1,
	'02d': icon2,
	'03d': icon3,
	'04d': icon4,
	'09d': icon5,
	'10d': icon6,
	'11d': icon7,
	'13d': icon8,
	'50d': icon9,
	'01n': icon10,
	'02n': icon11,
	'03n': icon3,
	'04n': icon4,
	'09n': icon5,
	'10n': icon12,
	'11n': icon7,
	'13n': icon8,
	'50n': icon9,
}